<template>
	<div class="my-20 flex item-start">
		<img :src="'http://124.222.209.62/atstudy-cateye/imgs/cust_avat/'+comment.custAvat" class="img-customer"/>
		<div class="ml-10 text-left">
			<div class="text-lg dark mt-5">{{comment.custName}}</div>
			<div class="mt-10 flex justify-between item-center comment-aggree">
				<div class="flex item-center">
					<div class="text-lg gray">{{comment.cmmtCreatetime}}</div>
					<div class="flex item-center ml-10">
						<template v-for="i in (1,5)">
							<img src="../assets/star_on.png" v-if="i<=parseInt(comment.cmmtScore/2)" class="img-star" />
							<img src="../assets/star_half.png" v-else-if="i-comment.cmmtScore/2<=0.5" class="img-star" />
							<img src="../assets/star_off.png" v-else class="img-star" />
						</template>
					</div>
				</div>
				<div class="flex item-center">
					<img src="../assets/aggree.png" class="hand"/>
					<div class="ml-5 gray text-sm">{{comment.cmmtGood}}</div>
				</div>
			</div>
			<div class="py-20 text-md gray border-bottom">{{comment.cmmtDesc}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['comment']
	}
</script>

<style>
</style>
